module.exports = __webpack_public_path__ + "img/stock.51862b72.svg";